import * as types from './types';

const initialState = {
  sorting: {},
};
export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case types.SET_SORTING:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};
